import { z } from 'zod';
import { InspectionCornSchema, NoteCornSchema } from '../base.js';
/** Title clients give the inspection summary note captured when completing an inspection. */
export const INSPECTION_SUMMARY_NOTE_TITLE = 'Inspection Summary';
export const NoteSchema = z.object({
    addedBy: z.string(),
    addedDate: z.string(),
    inspectionId: InspectionCornSchema,
    noteId: NoteCornSchema,
    text: z.string(),
    title: z.string().optional(),
});
